import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CargaRdsCuenta from "./cargaRdsCuenta";
// const items = ["pdn", "pdn-m1", "pdn-m2", "pdn-m3", "pdn-m4", "pdn-m5", "staging"];
const items = ["pdn", "pdn-m1", "pdn-m2", "pdn-m3", "pdn-m4", "pdn-m5", "pdn-m6"];

function cargaCpuLoadRds() {
  return items.map((cuenta, index) => (
    <Grid item xs={20} md={6} lg={3} key={cuenta || index}>
      <CargaRdsCuenta cuenta={cuenta} />
    </Grid>
  ));
}

export default cargaCpuLoadRds;
